/**
 * Sequential bingo celebration modals: bingo win first, then blackout (if both
 * apply on the same check-in)
 */
export default {
  data() {
    return {
      showBingoWinDialog: false,
      showBlackoutDialog: false,
      blackoutQueuedAfterBingo: false
    };
  },
  methods: {
    openBingoModalsFromCheckIn(result, hasBlackoutPrize) {
      if (!result) return;

      const hasBingoWin = (result.new_bingos ?? 0) > 0;
      const hasBlackout = !!(result.is_blackout && hasBlackoutPrize);

      this.blackoutQueuedAfterBingo = hasBingoWin && hasBlackout;

      if (hasBingoWin) {
        this.showBingoWinDialog = true;
        this.showBlackoutDialog = false;
      } else if (hasBlackout) {
        this.showBlackoutDialog = true;
        this.showBingoWinDialog = false;
      }
    },
    onBingoWinContinue() {
      this.blackoutQueuedAfterBingo = false;
      this.showBingoWinDialog = false;
      this.$nextTick(() => {
        this.showBlackoutDialog = true;
      });
    },
    onBingoWinDialogUpdate(open) {
      this.showBingoWinDialog = open;
    },
    onBlackoutDialogUpdate(open) {
      this.showBlackoutDialog = open;
    }
  }
};
